import { render } from "./datostipo.vue?vue&type=template&id=1195c946"
import script from "./datostipo.vue?vue&type=script&lang=js"
export * from "./datostipo.vue?vue&type=script&lang=js"

import "./datostipo.vue?vue&type=style&index=0&id=1195c946&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__